import { render, staticRenderFns } from "./primary-list.vue?vue&type=template&id=0ccc0dec&scoped=true&"
import script from "./primary-list.vue?vue&type=script&lang=js&"
export * from "./primary-list.vue?vue&type=script&lang=js&"
import style0 from "./primary-list.vue?vue&type=style&index=0&id=0ccc0dec&prod&lang=less&"
import style1 from "./primary-list.vue?vue&type=style&index=1&id=0ccc0dec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc0dec",
  null
  
)

export default component.exports